"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOriginalStockValue = void 0;
const catalog_messages_1 = require("@tableau/catalog-messages");
function isOriginalStockValue(labelValue) {
    const certifiedLabelValue = {
        name: 'CERTIFIED',
        description: catalog_messages_1.Messages.LabelValueCertifiedDescription(),
        elevatedDefault: false,
    };
    const extractRefreshFailureLabelValue = {
        name: 'EXTRACT_REFRESH_FAILURE',
        description: catalog_messages_1.Messages.LabelValueExtractRefreshDescription(),
        elevatedDefault: false,
    };
    const flowRunFailureLabelValue = {
        name: 'FLOW_RUN_FAILURE',
        description: catalog_messages_1.Messages.LabelValueFlowRunDescription(),
        elevatedDefault: false,
    };
    const warningLabelValue = {
        name: 'WARNING',
        description: catalog_messages_1.Messages.LabelValueWarningDescription(),
        elevatedDefault: false,
    };
    const deprecatedLabelValue = {
        name: 'DEPRECATED',
        description: catalog_messages_1.Messages.LabelValueDeprecatedDescription(),
        elevatedDefault: true,
    };
    const staleLabelValue = {
        name: 'STALE',
        description: catalog_messages_1.Messages.LabelValueStaleDescription(),
        elevatedDefault: true,
    };
    const sensitiveLabelValue = {
        name: 'SENSITIVE_DATA',
        description: catalog_messages_1.Messages.LabelValueSensitiveDescription(),
        elevatedDefault: true,
    };
    const maintenanceLabelValue = {
        name: 'MAINTENANCE',
        description: catalog_messages_1.Messages.LabelValueMaintenanceDescription(),
        elevatedDefault: false,
    };
    const stockLabelValues = [
        certifiedLabelValue,
        extractRefreshFailureLabelValue,
        flowRunFailureLabelValue,
        warningLabelValue,
        deprecatedLabelValue,
        staleLabelValue,
        sensitiveLabelValue,
        maintenanceLabelValue,
    ];
    return stockLabelValues.some(value => value.description === labelValue.description && value.elevatedDefault === labelValue.elevatedDefault
        && value.name === labelValue.name);
}
exports.isOriginalStockValue = isOriginalStockValue;
//# sourceMappingURL=StockLabelValue.js.map